import type { ReactNode } from 'react'

type BriefingStepListProps = {
  title: string
  description: string
  titleAccessory?: ReactNode
  children: ReactNode
}

export function BriefingStepList({
  title,
  description,
  titleAccessory,
  children,
}: BriefingStepListProps) {
  return (
    <section className='space-y-3'>
      <div className='space-y-1'>
        <div className='flex flex-wrap items-center gap-2'>
          <h2 className='text-lg font-semibold'>{title}</h2>
          {titleAccessory}
        </div>
        <p className='text-sm text-muted-foreground'>{description}</p>
      </div>
      <ol className='divide-y rounded-md border'>{children}</ol>
    </section>
  )
}
